import React from "react";
import * as S from "./style";
import { awardImages } from "./data";
import Image from '../../../../app/js/components/loggedout/common/Image';


const Awards = ({widthFull}) => {

  return (
    <S.ImageWrapper widthFull={widthFull} >
      {
        awardImages && awardImages.map((item, idx) => {
          return (
            <Image key={idx} src={item} />
          )
        })
      }
    </S.ImageWrapper>
  )
}

export default Awards;